export class OrderHistory {
    public userName: string;
    public orderState: string;
    public created?: Date;
}
